import React from 'react';
import { graphql } from 'gatsby';
import LayoutContainer from '../../containers/layout';
import SEO from '../../components/seo';
import TextComponent from '../../components/TextComponent/textComponent';
import CategorieDropdown from '../../components/CategorieDropdown/categorieDropdown';
import MediaContentBlock from '../../components/MediaContentBlock/mediaContentBlock';
import getDocumentLibraryData from '../../normalization/resourceCenter';
import './index.scss';
import { ALL_CATEGORIES_DEFAULT } from '../../utils/utils';

export const query = graphql`
  query DocumentLibrarySitePageQuery {
    site: sanitySiteSettings(_id: { regex: "siteSettings/" }) {
      title
      description
      keywords
    }
  }
`;
const DocumentLibrary = (props) => {
  const [category, setCategorie] = React.useState(ALL_CATEGORIES_DEFAULT);
  const defaultItem = { text: 'All Categories', value: ALL_CATEGORIES_DEFAULT };

  const handleCategory = (selectedCategory) => {
    setCategorie(selectedCategory);
  };
  const pageData = getDocumentLibraryData();
  const categories = pageData.categoryList;
  const { data } = props;
  const { site } = data || {};
  return (
    <LayoutContainer>
      <SEO title={`${site.title} | Resource Center`} description={site.description} keywords={site.keywords} />
      <div className="container-bg light-paw-style-big library-wrapper">
        <div className="container">
          <TextComponent heading={pageData.hero.headlineText} description={pageData.hero.description} />

          <div className="media-categories">
          <CategorieDropdown categories={categories} onSelectCategory={handleCategory} defaultItem={defaultItem} rightAlign />
            <MediaContentBlock mediaData={pageData.mediaData} selectedCategory={category} dataLimit={12} isMedia />
          </div>
        </div>
      </div>
    </LayoutContainer>
  );
};
export default DocumentLibrary;
